var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueApexChart',{attrs:{"type":"pie","series":_vm.pieChart.series,"options":_vm.pieChart.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }